import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import IconButton from 'components/icon-button'

import PlusIcon from '../../../../assets/icons/plus.svg'
import TickIcon from '../../../../assets/icons/tick.svg'

import styles from './grid-header-time-add.css'

const GridHeaderTimeAdd = ({ adding, fields, onAdd, onSubmit, style }) => (
  <div style={style} styleName="cell">
    <div
      styleName={adding ? 'content-adding' : 'content-normal'}
      onClick={adding ? null : onAdd}
    >
      {adding ?
        <form styleName="form" onSubmit={onSubmit}>
          <input
            autoFocus
            placeholder="22:00"
            styleName="input"
            type="text"
            {...fields.time}
          />
          <IconButton>
            <TickIcon />
          </IconButton>
        </form>
      :
        <IconButton label="Time" onClick={onAdd}>
          <PlusIcon />
        </IconButton>
      }
    </div>
  </div>
)

GridHeaderTimeAdd.propTypes = {
  adding: PropTypes.bool,
  fields: PropTypes.object,
  onAdd: PropTypes.func,
  onSubmit: PropTypes.func,
  style: PropTypes.object,
}

export default CSSModules(GridHeaderTimeAdd, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header-time-add/grid-header-time-add.js
 **/